var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mercur-item',{attrs:{"to":_vm.getRouteForName('ProductContentCategoriesView')}},[_c('i',{staticClass:"fas fa-tags"}),_c('span',[_vm._v("Categories")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }